module.exports = __webpack_public_path__ + "static/media/icon-google-login.a6df8a53.svg";